import { pushDataLayer } from "utils/googletagmanager"
import { GTM_COUNT_KIOSK_USERS } from "constant"

export const gtmPushDataLayerCountKioskUser = () => {
  pushDataLayer({
    event: GTM_COUNT_KIOSK_USERS,
  })
}
